module.exports = __webpack_public_path__ + "static/media/logoTop.c9d7a4f4.png";